import Quill from 'quill';
import "quill/dist/quill.core.css";

const Delta = Quill.import('delta');

class EventEditor {
    constructor() {

        const toolbarOptions = [
            ['bold', 'italic', 'underline', { 'list': 'ordered'}, { 'list': 'bullet'} ],
        ];
        
        this.body = document.getElementById("event-body");
        this.contents = document.getElementById("event-contents");
        this.counter = document.getElementById("wysihtml-counter");
        this.label = document.querySelector('label[for="event-body"]');
        this.maxChars = parseInt(this.counter.dataset.max, 10);

        this.translations = {
            maxCharsExceeded: this.body?.dataset.msgMaxCharsExceeded || 'This field has more characters than the maximum allowed',
            requiredField: this.body?.dataset.msgRequiredField || 'Please fill in the required field',
        };

        this.quill = new Quill(this.body, {
            theme: 'snow',
            modules: {
                toolbar: toolbarOptions,
                clipboard: {
                    matchVisual: false,
                    matchers: [
                      ['span', this.customMatcherFunction]
                    ]
                }
            }
          });

        this.quill.clipboard.dangerouslyPasteHTML(this.contents.innerHTML);

        this.quill.clipboard.addMatcher(Node.ELEMENT_NODE, (node, delta) => {
            const ops = [];
            delta.ops.forEach(op => {
              if (op.insert) {
                ops.push({
                  insert: op.insert
                });
              }
            });
            return new Delta(ops);
          });
        this.updateCounter();

        this.quill.on('text-change', () => {
            this.body.classList.remove("error");
            this.updateCounter();
        });
    }

    customMatcherFunction(node, delta) {
        return delta.compose(new Delta().retain(delta.length(), {
          color: undefined,
          background: undefined,
          font: undefined,
          size: undefined,
          style: undefined
        }));
      }

    getContents() {
        return this.quill.root.innerHTML;
    }

    updateCounter() {
        const textLength = this.quill.getText().trim().length;
        this.counter.textContent = `${textLength}/${this.maxChars}`;
        
        if (textLength >= this.maxChars) {
            this.counter.style.color = 'red';
        } else if (textLength >= this.maxChars * 0.9) {
            this.counter.style.color = 'orange';
        } else {
            this.counter.style.color = '';
        }
    }

    validate(errors, formData) {
        if (this.counter.style.color == 'red') {
            alert(this.translations.maxCharsExceeded);
            this.body.classList.add("error");
            window.scrollTo({ top: this.label.getBoundingClientRect().top  + window.scrollY - 160, behavior: 'smooth'});
            errors.push(this.counter);
        } else if (this.quill.getText().trim().length == 0) {
            alert(this.translations.requiredField);
            this.body.classList.add("error");
            window.scrollTo({ top: this.label.getBoundingClientRect().top  + window.scrollY - 160, behavior: 'smooth'});
            errors.push(this.counter);
        } else {
            formData.append('event-contents', this.quill.root.innerHTML);
        }
    }
}

const initEditor = () => {
    if (document.getElementById("event-body")) {
        return new EventEditor();
    }
    return null;
};

export default initEditor;

window.eventEditor = initEditor;